import { SqlImportDatabase } from 'cio/utils/sql-import';
import pluralize from 'cio/utils/pluralize';

import {
  DataFlow,
  IntegrationCategory,
  IntegrationIDs,
  IntegrationNames,
  IntegrationType,
} from 'cio/utils/integrations/static-integrations';
import SqlImportModel from 'cio/models/sql-import';

function getSqlDatabaseIntegrationIds(type: SqlImportDatabase) {
  return {
    [SqlImportDatabase.mysql]: IntegrationIDs.mysql,
    [SqlImportDatabase.postgres]: IntegrationIDs.postgres,
    [SqlImportDatabase.snowflake]: IntegrationIDs.snowflakeIn,
    [SqlImportDatabase.bigQuery]: IntegrationIDs.bigQueryIn,
    [SqlImportDatabase.redshift]: IntegrationIDs.redshiftIn,
    [SqlImportDatabase.sqlserver]: IntegrationIDs.sqlserver,
  }[type];
}

function getSqlDatabaseIntegrationName(type: SqlImportDatabase) {
  return {
    [SqlImportDatabase.mysql]: IntegrationNames.mysql,
    [SqlImportDatabase.postgres]: IntegrationNames.postgres,
    [SqlImportDatabase.snowflake]: IntegrationNames.snowflakeIn,
    [SqlImportDatabase.bigQuery]: IntegrationNames.bigQueryIn,
    [SqlImportDatabase.redshift]: IntegrationNames.redshiftIn,
    [SqlImportDatabase.sqlserver]: IntegrationNames.sqlserver,
  }[type];
}

function getSqlDatabaseImageSrc(type: SqlImportDatabase) {
  return {
    [SqlImportDatabase.mysql]: new URL('cio/assets/images/integrations/mysql.svg', import.meta.url).toString(),
    [SqlImportDatabase.postgres]: new URL('cio/assets/images/integrations/postgresql.svg', import.meta.url).toString(),
    [SqlImportDatabase.snowflake]: new URL('cio/assets/images/integrations/snowflake.svg', import.meta.url).toString(),
    [SqlImportDatabase.bigQuery]: new URL('cio/assets/images/integrations/bigquery.svg', import.meta.url).toString(),
    [SqlImportDatabase.redshift]: new URL('cio/assets/images/integrations/redshift.svg', import.meta.url).toString(),
    [SqlImportDatabase.sqlserver]: new URL('cio/assets/images/integrations/sqlserver.svg', import.meta.url).toString(),
  }[type];
}

function getSqlDatabaseOverview(type: SqlImportDatabase) {
  return {
    [SqlImportDatabase.mysql]: 'Sync people/objects from your MySQL database to Customer.io',
    [SqlImportDatabase.postgres]: 'Sync people/objects from your PostgreSQL database to Customer.io',
    [SqlImportDatabase.snowflake]: 'Sync people/objects from Snowflake to Customer.io',
    [SqlImportDatabase.bigQuery]: 'Sync people/objects from BigQuery to Customer.io',
    [SqlImportDatabase.redshift]: 'Sync people/objects from your Redshift database to Customer.io',
    [SqlImportDatabase.sqlserver]: 'Sync people/objects from Sql Server to Customer.io',
  }[type];
}

export function mapSqlDatabaseIntegration(sqlImports: SqlImportModel[], type: SqlImportDatabase) {
  let total = sqlImports.length ?? 0;
  let totalActive = sqlImports.filterBy('active').length ?? 0;

  return {
    id: getSqlDatabaseIntegrationIds(type),
    forceOrder: 0,
    imageSrc: getSqlDatabaseImageSrc(type),
    name: getSqlDatabaseIntegrationName(type),
    overview: getSqlDatabaseOverview(type),
    enabledStatus: totalActive > 0 ? `${totalActive} active ${pluralize(totalActive, 'sync')}` : 'No active syncs',
    category: IntegrationCategory.databases,
    enabled: total > 0,
    beta: false,
    type: IntegrationType.native,
    publicType: IntegrationType.existing,
    path: 'sql-imports',
    dynamicSegment: type,
    dataFlow: DataFlow.in,
    total,
  };
}
